import {Helmet} from "react-helmet";
import {Button, Container, Grid, TextField, Typography} from "@mui/material";
import {useState} from "react";
import Toasty from "../../../theme/components/Toasty";
import {useNavigate} from "react-router-dom";

export default function SeeShare() {

    const [linkAddress, setLinkAddress] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!linkAddress) return Toasty.error('لطفا لینک را وارد نمایید');
        navigate(`/share/${linkAddress}`);
    }

    return (
        <>
            <Helmet>
                <title>درایو میلفا - مشاهده کد اشتراک گذاری</title>
                </Helmet>
            <Container sx={{ mt: 3 }}>
                <Typography fontSize={{ xs: "1.1rem", lg: "1.1rem" }} fontWeight={600}>مشاهده کد اشتراک گذاری</Typography>
                <Grid mt={1} component="form" onSubmit={handleSubmit} container spacing={2}>
                    <Grid item xs={12} lg={4}>
                        <TextField
                            vlaue={linkAddress} onChange={(e) => setLinkAddress(e.target.value)}
                            fullWidth
                            label='کد اشتراک گذاری' placeholder='لطفا کد اشتراک گذاری را وارد کنید'/>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <Button
                            type="submit"
                            fullWidth variant="contained"
                            disableElevation sx={{ py: 1.5, height: 1 }}>مشاهده</Button>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}